const actions = {
  initSiteSettings(store) {
    const { commit } = store;
    const defaultDashboardView = localStorage.getItem('defaultDashboardView') || 'projects';
    const defaultControlPointsView = localStorage.getItem('defaultControlPointsView') || 'board';
    commit('setSiteSettings', { 
      defaultDashboardView,
      defaultControlPointsView,
    });
  },
  setDefaultDashboardView(store, defaultDashboardView) {
    const { commit } = store;
    localStorage.setItem('defaultDashboardView', defaultDashboardView);
    commit('setSiteSettings', { defaultDashboardView });
  },
  setDefaultControlPointsView(store, defaultControlPointsView) {
    const { commit } = store;
    localStorage.setItem('defaultControlPointsView', defaultControlPointsView);
    commit('setSiteSettings', { defaultControlPointsView });
  },
};

export default actions;
